module.exports = __webpack_public_path__ + "img/Brittany.78ff7804.jpg";